import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '../../../components'
import {
  Breadcrumbs,
  PageContent,
  PageHeader
} from '../../../layout/components'
import { AbcClientsReportForm } from './components/Form'
import { AbcClientsProvider } from './context/abcClients.context'

export const AbcClientsReport = () => {
  const navigation = useNavigate()
  return (
    <div>
      <PageHeader>
        <div
          style={{
            fontSize: 22,
            fontWeight: 800,
            marginBottom: '.5rem',
            height: 40,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <IconButton
            onClick={() => navigation('/reports')}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <MdKeyboardArrowLeft
              size={24}
              color="#565656"
              style={{ background: '' }}
            />
          </IconButton>
          <div style={{ marginLeft: '1rem', fontSize: 22, fontWeight: 800 }}>
            Curva ABC de Clientes
          </div>
        </div>
        <Breadcrumbs
          links={[{ url: 'reports', name: 'Relatórios' }]}
          span="Relatório Curva ABC de Clientes"
        ></Breadcrumbs>
      </PageHeader>
      <PageContent>
        <AbcClientsReportForm />
      </PageContent>
    </div>
  )
}

export const AbcClientsReportPage = () => (
  <AbcClientsProvider>
    <AbcClientsReport />
  </AbcClientsProvider>
)

export default AbcClientsReportPage
